import React from 'react';
import './index.scss';

const ModalContainer = ({ children }) => {
  return (
    <div className="store-directory_theme">
      <div className="app-container">{children}</div>
      <div id="modal-container"></div>
    </div>
  );
};

export default ModalContainer;
